// extracted by mini-css-extract-plugin
module.exports = {"outOfStock":"_1DJYm"};